export const SHIPPING_METHOD_QUERY_KEY = 'shipping-method';
export const SHIPPING_METHODS_QUERY_KEY = 'shipping-methods';
